export const getCotivaToken = () => {
    return sessionStorage.getItem("cortiva_token")
}

export const setCotivaToken = (token) => {
    sessionStorage.setItem("cortiva_token", token);
}

export const cortivaUrl = 'https://retailerapi2.roots.biz/api';
